export default __webpack_public_path__ + "static/media/paper.6b92ee12.png";